<!-- https://docs.google.com/presentation/d/1kEqw8_oTr22Y1IZE5zl0ZSZN1cdyGy0e5eyhrMvr_k8/edit#slide=id.g1fb42898836_0_30 
https://xd.adobe.com/view/d3a0016d-0148-4820-871d-6757f32740ff-86f3/screen/9567a2c4-b36e-4cb1-9fac-0a1a130d2db1/specs/
https://xd.adobe.com/view/f344cbd5-67ae-4ef0-8cfc-8b8f917363a3-a617/screen/5aed5750-a5d4-4dc4-9b28-5d8e1cc4c604/
https://docs.google.com/presentation/d/13DjloAasiqfqm-6VGRySINWB2MYHqoIVVmgyvi2sUaE/edit#slide=id.g1eec1f12343_0_17
https://docs.google.com/presentation/d/1kEqw8_oTr22Y1IZE5zl0ZSZN1cdyGy0e5eyhrMvr_k8/edit#slide=id.p
https://xd.adobe.com/view/c6fa2e7c-6822-4379-91db-03c7de29a5b4-93a9/screen/0861760b-352a-4282-b352-f2e9609cbecf/
-->
<template>
    <div id="TenderFolder" class="clearfix gibson px2 mb4">
        <div class="mt2 pointer">
          <i class="el-icon-back" @click="gotomenikunder()"></i>
        </div>
        <div class="col-12 mt2 px0 flex justify-start items-start flex-column">
            <p class="h2 regular line-height-2 mt2">{{projectTitle}}</p>
            <p class="h5 regular line-height-2">{{projectAddress}}</p>
            <p class="pointer" @click="folderChange(67970, 'Public', '67967', 4,'in')">Se offentlige dokumenter</p>
            <p class="line-height-golden font14 darkblue m0">Her finder du den fulde oversigt over materialet i udbuddet. Du kan stille uddybende spørgsmål til materialet, se arbejdsbeskrivelse og betingelser, tilgå eventuelle dokumenter i arkiv, samt se inspiration fra kunden, såfremt dette er uploadet. Til sidst finder du det tilbud, du har givet kunden, når dette er afgivet.</p>
        </div>
        <div class="clearfix" v-if="loading">
          <Loading></Loading>
        </div>
        <div class="col-12 p0" v-else>
          <div class="">
            <ol class="breadcrumb transparent px0 mb-0">
              <li class="h6 breadcrumb-item pointer" v-for="(folder, index) in parentFolderData" :key="index"
                @click="folderChange(folder.folderId, folder.folderName, currentFolderParentId, index, 'out')">
                <a>{{ folder.folderName }}</a>
              </li>
            </ol>
        </div>
            <p class="m0 h6 p0 col-12 flex justify-start my2"  v-if="insideFolder !== 'in'">Udbudsmappe</p>
            <div class="flex flex-wrap pb4 mt1 gap-15">
              <!-- eslint-disable -->
              <!-- <div class="pointer mx2 flex flex-column border light-highlights p2 px3" v-for="(item,index) in documentsData" :key="index" @click="openpdfdownload(item.pdfbase64)"> -->
              <div class="flex flex-column border light-highlights p2 items-center pointer" style="width: 162px; height: 151px;" @click="opentenderqa()" v-if="selectedFolder !== 'Public' && selectedFolder !== 'Offers' && selectedFolder !== 'Inspiration' && selectedFolder !== 'Archive' && offerStatus !== 'accepted'">
                <span class="darkblue">
                  <svg xmlns="http://www.w3.org/2000/svg" width="65.547" height="75" viewBox="0 0 65.547 75">
                    <path id="Path_4061" data-name="Path 4061" d="M5876.205-238a9.224,9.224,0,0,1-2.085-.241.292.292,0,0,0-.047-.011c-.175-.044-.354-.093-.543-.15,0,0,0,0-.006,0a.227.227,0,0,1-.044-.014.227.227,0,0,0-.041-.011l-.188-.063c-.088-.03-.178-.063-.266-.1h0l-.037-.016a.407.407,0,0,0-.053-.019c-.186-.071-.354-.145-.52-.219,0,0,0,0,0,0s0,0-.006,0c-.146-.068-.3-.148-.473-.24a.494.494,0,0,1-.057-.033c-.02-.011-.039-.019-.061-.03-.137-.077-.273-.156-.4-.235a.2.2,0,0,0-.029-.022l-.047-.025c-.15-.1-.3-.2-.448-.309-.016-.011-.029-.025-.046-.036s-.036-.025-.053-.038h0c-.115-.085-.229-.175-.339-.265l-.044-.041a.836.836,0,0,1-.071-.057h0a0,0,0,0,0,0,0c-.046-.038-.092-.079-.137-.118-.1-.085-.183-.167-.265-.246l-5.9-5.66a0,0,0,0,0,0,0s0,0,0,0c-.112-.109-.228-.227-.356-.363h-3.232a6.4,6.4,0,0,1-6.393-6.39V-306.61a6.4,6.4,0,0,1,6.393-6.39h35.533a6.4,6.4,0,0,1,6.39,6.39v.519h2.384a4.8,4.8,0,0,1,4.8,4.794v25.922a34.352,34.352,0,0,1,8.806,6.764,4.709,4.709,0,0,1,0,6.381,34.317,34.317,0,0,1-8.806,6.764v12.673a4.8,4.8,0,0,1-4.8,4.794Zm-12.1-23.145v8.355c0,.087,0,.178,0,.268,0,.03,0,.06.006.09,0,.06.008.117.014.178v.022h7.926a3.825,3.825,0,0,1,3.82,3.821v7.475c.109.005.216.008.325.008H5904.7a1.868,1.868,0,0,0,1.866-1.864h0v-11.3q-1.226.5-2.484.894l-.18.057c-.129.038-.258.079-.389.115s-.268.079-.4.115c-.1.027-.2.057-.3.085-.2.052-.4.1-.6.153l-.159.038a30.44,30.44,0,0,1-9.554.752l-.15-.011-.521-.049-.29-.03c-.106-.011-.216-.025-.322-.038-.252-.03-.5-.066-.749-.1l-.077-.011a30.931,30.931,0,0,1-7.692-2.192c-.039-.016-.079-.033-.12-.052-.161-.071-.323-.142-.484-.216l-.161-.074c-.47-.216-.932-.443-1.392-.683-.1-.052-.2-.1-.295-.156s-.221-.117-.33-.178l-.336-.189c-.1-.055-.2-.112-.3-.169-.143-.082-.287-.167-.429-.254l-.2-.12c-.205-.126-.41-.254-.613-.383-.067-.044-.137-.087-.2-.134-.147-.093-.295-.191-.439-.29-.071-.046-.145-.1-.216-.145-.151-.1-.3-.208-.452-.314-.057-.041-.114-.082-.174-.123-.208-.15-.413-.3-.617-.454a.247.247,0,0,0-.036-.027q-.287-.217-.573-.443c-.059-.044-.113-.09-.17-.137-.148-.118-.3-.238-.443-.358-.06-.049-.12-.1-.177-.15-.165-.134-.326-.273-.484-.413-.035-.03-.074-.06-.109-.093-.193-.172-.388-.344-.582-.522-.043-.038-.085-.079-.128-.12-.151-.137-.3-.276-.443-.415-.06-.057-.12-.117-.184-.175-.134-.131-.267-.262-.4-.4-.058-.055-.112-.112-.169-.167-.184-.189-.367-.374-.548-.566a4.709,4.709,0,0,1,0-6.381c.181-.191.364-.38.548-.566.057-.057.111-.112.169-.167.132-.134.265-.265.4-.4l.184-.175c.147-.142.292-.279.44-.415.046-.041.088-.082.131-.12.194-.178.389-.353.582-.522.038-.033.074-.063.109-.1.161-.137.319-.276.481-.41l.18-.15c.147-.12.295-.238.44-.358.06-.046.117-.09.175-.137.188-.15.377-.3.568-.44l.039-.03c.2-.153.409-.3.617-.454.06-.041.117-.082.177-.126l.446-.312.221-.148.432-.287c.071-.044.141-.09.208-.134.2-.131.408-.257.613-.383.067-.044.139-.082.21-.126.139-.085.278-.167.418-.249l.3-.172c.108-.063.221-.123.33-.183s.224-.123.34-.183c.092-.052.185-.1.28-.15.465-.243.933-.473,1.407-.691l.151-.068c.163-.074.327-.148.492-.219l.111-.049a31.034,31.034,0,0,1,7.7-2.192c.025-.005.053-.008.077-.014.252-.035.5-.068.755-.1.106-.014.21-.027.316-.038s.194-.022.29-.03c.174-.019.347-.033.52-.049.051,0,.1-.008.155-.014a30.454,30.454,0,0,1,9.543.752c.058.014.117.027.175.044.189.044.375.093.563.142l.363.1c.12.033.241.068.358.1l.407.123c.049.016.1.03.149.046q1.269.4,2.507.9V-301.3a1.868,1.868,0,0,0-1.866-1.864h-38.726a1.866,1.866,0,0,0-1.864,1.864v28.433a1.465,1.465,0,0,1-1.466,1.465,1.464,1.464,0,0,1-1.464-1.465V-301.3a4.8,4.8,0,0,1,4.794-4.794h33.412v-.519a3.464,3.464,0,0,0-3.46-3.46h-35.533a3.465,3.465,0,0,0-3.463,3.46v53.648a3.465,3.465,0,0,0,3.463,3.46h1.4c-.016-.038-.029-.077-.043-.115-.022-.057-.041-.112-.063-.169a.066.066,0,0,0-.008-.022v0a.16.16,0,0,1-.008-.027c-.011-.03-.021-.063-.031-.093,0,0,0,0,0,0-.014-.044-.024-.087-.038-.128s-.035-.109-.052-.164c-.006-.022-.012-.041-.018-.06-.019-.06-.032-.12-.048-.178-.009-.033-.02-.066-.027-.1-.028-.115-.056-.229-.08-.347,0-.005,0-.011,0-.019-.021-.107-.042-.216-.061-.325-.006-.036-.011-.074-.017-.109-.014-.079-.026-.159-.038-.241,0-.041-.011-.085-.013-.126-.01-.077-.018-.153-.025-.23,0-.041-.009-.085-.011-.126-.006-.082-.011-.161-.017-.243,0-.036,0-.074-.006-.112,0-.117,0-.232,0-.35v-8.355a1.464,1.464,0,0,1,1.464-1.465A1.465,1.465,0,0,1,5864.109-261.145Zm1.314,12.17,0,.005c.011.016.022.03.033.044a.291.291,0,0,1,.025.03c.062.074.125.148.188.221.016.016.026.033.04.049l.033.033c.1.107.183.194.265.273l5.9,5.663c.049.047.1.1.161.15.035.03.073.063.117.1a.169.169,0,0,0,.033.03c.014.014.029.022.043.036.077.063.156.123.235.183.012.008.022.019.036.03a.163.163,0,0,1,.026.019c.1.074.205.142.307.208l.016.011a.148.148,0,0,0,.036.019l.027.016v-6.556a.891.891,0,0,0-.891-.891h-6.873C5865.262-249.191,5865.342-249.082,5865.424-248.975Zm18.768-16.447a10.716,10.716,0,0,0,10.7,10.7,10.717,10.717,0,0,0,10.7-10.7,10.716,10.716,0,0,0-10.7-10.7A10.715,10.715,0,0,0,5884.191-265.422Zm24.337,0a13.574,13.574,0,0,1-3.075,8.617q.93-.381,1.851-.834a31.178,31.178,0,0,0,8.865-6.6,1.809,1.809,0,0,0,0-2.359,31.171,31.171,0,0,0-8.877-6.608c-.147-.074-.3-.148-.445-.216a.082.082,0,0,1-.021-.011c-.454-.213-.913-.413-1.372-.6A13.572,13.572,0,0,1,5908.528-265.422Zm-31.266-4.5a.639.639,0,0,1-.058.044c-.123.1-.245.194-.365.292l-.181.148c-.106.087-.213.175-.319.265-.083.068-.165.139-.247.208s-.175.15-.262.229q-.246.213-.486.435c-.063.057-.123.115-.187.172-.114.107-.229.213-.341.322-.063.06-.124.12-.187.18-.12.115-.238.232-.358.353-.048.049-.1.1-.152.15-.167.172-.334.344-.5.519a1.726,1.726,0,0,0-.437,1.178,1.746,1.746,0,0,0,.337,1.058,1.205,1.205,0,0,0,.1.123c.163.172.33.344.5.514l.164.164c.114.115.229.227.345.339l.2.189c.107.1.216.2.325.309.068.063.134.126.2.186.155.142.312.284.474.424.092.085.19.164.283.246l.23.2c.109.09.218.183.327.273.058.044.112.09.17.137.123.1.248.2.374.3.017.011.03.022.044.033a29.843,29.843,0,0,0,7.084,4.124,13.553,13.553,0,0,1-3.074-8.611,13.558,13.558,0,0,1,3.074-8.611A30.007,30.007,0,0,0,5877.263-269.917Zm10.21,4.5a7.431,7.431,0,0,1,7.423-7.42,7.428,7.428,0,0,1,7.42,7.42A7.429,7.429,0,0,1,5894.9-258,7.431,7.431,0,0,1,5887.473-265.422Zm2.93,0a4.5,4.5,0,0,0,4.493,4.493,4.5,4.5,0,0,0,4.49-4.493,4.5,4.5,0,0,0-4.49-4.49A4.5,4.5,0,0,0,5890.4-265.422Zm-28.045-.145a1.521,1.521,0,0,1-.273-.085,1.452,1.452,0,0,1-.255-.134,1.5,1.5,0,0,1-.224-.183,1.479,1.479,0,0,1-.181-.221,1.454,1.454,0,0,1-.133-.254,1.35,1.35,0,0,1-.085-.273,1.433,1.433,0,0,1-.03-.287,1.455,1.455,0,0,1,.03-.287,1.407,1.407,0,0,1,.085-.273,1.531,1.531,0,0,1,.133-.251,1.5,1.5,0,0,1,.181-.224,1.486,1.486,0,0,1,1.323-.4,1.228,1.228,0,0,1,.275.085,1.452,1.452,0,0,1,.252.131,1.677,1.677,0,0,1,.222.183,1.4,1.4,0,0,1,.184.224,1.546,1.546,0,0,1,.136.251,1.63,1.63,0,0,1,.082.273,1.455,1.455,0,0,1,.03.287,1.433,1.433,0,0,1-.03.287,1.555,1.555,0,0,1-.082.273,1.466,1.466,0,0,1-.136.254,1.385,1.385,0,0,1-.184.221,1.487,1.487,0,0,1-.222.183,1.46,1.46,0,0,1-.252.134,1.517,1.517,0,0,1-.275.085,1.428,1.428,0,0,1-.285.027A1.459,1.459,0,0,1,5862.357-265.567Zm8.945-13.156a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h7.972a1.465,1.465,0,0,1,1.467,1.465,1.465,1.465,0,0,1-1.467,1.465Zm0-8.057a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h18.641a1.465,1.465,0,0,1,1.465,1.465,1.465,1.465,0,0,1-1.465,1.465Zm0-8.057a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h25.782a1.465,1.465,0,0,1,1.465,1.465,1.465,1.465,0,0,1-1.465,1.465Z" transform="translate(-5854 313)" fill="#003645"/>
                  </svg>
                </span>
                <span class="center m0">Spørgsmål og svar</span>
              </div>
              <div class="pointer flex flex-column items-center border light-highlights p2 px3" style="width: 162px;height: 151px;" v-for="(item,index) in documentsData" :key="index" v-if="insideFolder !== 'in' && item.NAME !== 'Public'">
                <div class='flex flex-column items-center' v-if="item.TYPE !== 'folder'" @click="openpdfdownload(item.pdfbase64)">
                  <el-tooltip :content="item.NAME" placement="top-start" effect="light" >
                    <span class="darkblue">
                      <svg xmlns="http://www.w3.org/2000/svg" id="pdf_ic" width="55" height="75" viewBox="0 0 55 75">
                        <path id="Path_392" data-name="Path 392" d="M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z" transform="translate(-28.492 -31.709)" fill="#003645"/>
                        <path id="Path_393" data-name="Path 393" d="M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z" transform="translate(0 0)" fill="#003645"/>
                        <path id="Path_394" data-name="Path 394" d="M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z" transform="translate(-32.976 -134.449)" fill="#003645"/>
                        <path id="Path_395" data-name="Path 395" d="M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z" transform="translate(-58.222 -134.456)" fill="#003645"/>
                        <path id="Path_396" data-name="Path 396" d="M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z" transform="translate(-83.969 -134.456)" fill="#003645"/>
                      </svg>
                    </span>
                  </el-tooltip>
                  <!-- <span class="darkblue center">Arbejdsbeskrivelse <br> & Betingelser</span> -->
                  <el-tooltip :content="item.NAME" placement="top-start" effect="light" >
                      <span class="darkblue center" style="overflow-wrap: anywhere;">{{ item.NAME | truncate(20, '...') }}</span>
                  </el-tooltip>
                </div>
                <div class='flex flex-column' v-if="item.TYPE === 'folder'" @click="folderChange(item.ID, item.NAME, item.PARENT_ID, index,'in')">
                <el-tooltip :content="item.NAME" placement="top-start" effect="light" >
                  <span class="darkblue">
                  <svg xmlns="http://www.w3.org/2000/svg" width="55" height="73.542" viewBox="0 0 55 73.542">
                    <path id="Filer" d="M-914.761-38.458c-4,0-5.749-4.627-6.208-7.848l-.03-.213v-57.307a10.075,10.075,0,0,1,1.556-6,5.24,5.24,0,0,1,5.337-2.073h13.246l5.311,12.028h4.292c.663,0,1.2.869,1.2,1.94s-.535,1.937-1.2,1.937h-5.527l-5.311-12.028h-12.182l-.088-.021a3.562,3.562,0,0,0-3.518,1.162,5.228,5.228,0,0,0-.719,3.053v56.84c.183,1.068,1.2,6.11,4.016,6.11h42.075c.568-.157,4.113-1.323,4.113-6.075v-43.28a13.41,13.41,0,0,0-.6-3.137c-.622-1.842-1.58-2.739-2.933-2.739h-6.927c-.662,0-1.2-.865-1.2-1.937s.537-1.94,1.2-1.94h6.927c2.251,0,4.057,1.741,5.084,4.9A19,19,0,0,1-866-90.434l0,.122v43.36c0,6.752-4.267,7.991-6.429,8.476l-.082.017Zm28.784-58.016a2.8,2.8,0,0,1-.367-1.434,2.8,2.8,0,0,1,.367-1.434,1.086,1.086,0,0,1,.88-.593,1.091,1.091,0,0,1,.883.593,2.823,2.823,0,0,1,.365,1.434,2.823,2.823,0,0,1-.365,1.434,1.091,1.091,0,0,1-.883.593A1.086,1.086,0,0,1-885.977-96.474Z" transform="translate(921 112)" fill="#003645"/>
                  </svg>
                  </span>
                </el-tooltip>
                <span class="darkblue center" v-if="item.NAME === 'Offers'">Tilbud</span>
                <span class="darkblue center" v-else-if="item.NAME === 'Archive'">Arkiv</span>
                <span class="darkblue center" v-else>Inspiration</span>
                </div>
              </div>
              <!-- eslint-disable -->
              <!-- Inside Folder -->
            </div>
            <div class="flex flex-wrap border border-top-0 border-left-0 border-right-0 pb4 mt1 center" v-if="selectedFolder === 'Public' && insideFolder === 'in'">
              <p class="m0 h6 col-12 flex justify-start my2">Offentlige filer</p>
              <div class="flex flex-column col-12 m0 p0" v-if="publicFiles.length < 1">
                <p class="m0 h6" >Vi får de offentlige filer på denne adresse, så snart vi er færdige. Venligst vend tilbage senere for at se alle filer</p>
              </div>
              <!-- eslint-disable -->
              <div class="" v-for="(file,index) in publicFiles" :key="index" v-else @click="openpdfdownload(file.UF_LINK)">
                  <div class="pointer mx2 flex flex-column border light-highlights p2 mb3" style="width: 130px;">
                    <el-tooltip content="" placement="top-start" effect="light">
                    <p slot="content" v-html="file.UF_DESCRIPTION"></p>
                      <span class="darkblue">
                        <svg xmlns="http://www.w3.org/2000/svg" id="pdf_ic" width="55" height="75" viewBox="0 0 55 75">
                          <path id="Path_392" data-name="Path 392" d="M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z" transform="translate(-28.492 -31.709)" fill="#134553"/>
                          <path id="Path_393" data-name="Path 393" d="M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z" transform="translate(0 0)" fill="#134553"/>
                          <path id="Path_394" data-name="Path 394" d="M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z" transform="translate(-32.976 -134.449)" fill="#134553"/>
                          <path id="Path_395" data-name="Path 395" d="M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z" transform="translate(-58.222 -134.456)" fill="#134553"/>
                          <path id="Path_396" data-name="Path 396" d="M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z" transform="translate(-83.969 -134.456)" fill="#134553"/>
                        </svg>
                      </span>
                    </el-tooltip>
                    <el-tooltip :content="file.UF_YEAR + '_' + file.UF_ADDRESS_TYPE" placement="top-start" effect="light" >
                      <span class="darkblue center">{{file.UF_YEAR !== null ? truncate(file.UF_YEAR.trim() + '_' + file.UF_ADDRESS_TYPE, 10, '..') : 'file_' + index}}</span>
                    </el-tooltip>
                  </div>
              </div>
              <!-- eslint-enable -->
            </div>
            <!-- Offer -->
            <div class="border border-top-0 border-left-0 border-right-0 pb4 mt1 center" v-if="selectedFolder === 'Offers' && tenderOfferFiles.length > 0">
                <!-- eslint-disable -->
                <div class="" @click="openpdfdownload(tenderfilesOffer.URL)">
                    <div class="pointer mx2 flex flex-column border light-highlights p2 mb3" style="width: 130px;">
                      <el-tooltip :content="projectTitle + '-' + projectID + '-' + 'Offers'" placement="top-start" effect="light">
                      <p slot="content" v-html="projectTitle + '-' + projectID + '-' + 'Offers'"></p>
                        <span class="darkblue">
                          <svg xmlns="http://www.w3.org/2000/svg" id="pdf_ic" width="55" height="75" viewBox="0 0 55 75">
                            <path id="Path_392" data-name="Path 392" d="M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z" transform="translate(-28.492 -31.709)" fill="#134553"/>
                            <path id="Path_393" data-name="Path 393" d="M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z" transform="translate(0 0)" fill="#134553"/>
                            <path id="Path_394" data-name="Path 394" d="M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z" transform="translate(-32.976 -134.449)" fill="#134553"/>
                            <path id="Path_395" data-name="Path 395" d="M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z" transform="translate(-58.222 -134.456)" fill="#134553"/>
                            <path id="Path_396" data-name="Path 396" d="M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z" transform="translate(-83.969 -134.456)" fill="#134553"/>
                          </svg>
                        </span>
                      </el-tooltip>
                      <el-tooltip :content="projectTitle + '-' + projectID + '-' + 'Offers'" placement="top-start" effect="light" >
                        <span class="darkblue center">{{ projectTitle + '-' + projectID  + '-' + 'Offers'}}</span>
                      </el-tooltip>
                    </div>
                </div>
              <!-- eslint-enable -->
            </div>
            <div class="border border-top-0 border-left-0 border-right-0 pb4 mt1 center" v-if="selectedFolder === 'Inspiration' && tenderInspirationFiles.length > 0">
                  <!-- eslint-disable -->
                  <div class="" @click="openpdfdownload(tenderfilesInspiration.URL)">
                      <div class="pointer mx2 flex flex-column border light-highlights p2 mb3" style="width: 130px;">
                        <el-tooltip :content="projectTitle + '-' + projectID + '-' + 'Inspiration'" placement="top-start" effect="light">
                        <p slot="content" v-html="projectTitle + '-' + projectID + '-' + 'Inspiration'"></p>
                          <span class="darkblue">
                            <svg xmlns="http://www.w3.org/2000/svg" id="pdf_ic" width="55" height="75" viewBox="0 0 55 75">
                              <path id="Path_392" data-name="Path 392" d="M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z" transform="translate(-28.492 -31.709)" fill="#134553"/>
                              <path id="Path_393" data-name="Path 393" d="M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z" transform="translate(0 0)" fill="#134553"/>
                              <path id="Path_394" data-name="Path 394" d="M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z" transform="translate(-32.976 -134.449)" fill="#134553"/>
                              <path id="Path_395" data-name="Path 395" d="M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z" transform="translate(-58.222 -134.456)" fill="#134553"/>
                              <path id="Path_396" data-name="Path 396" d="M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z" transform="translate(-83.969 -134.456)" fill="#134553"/>
                            </svg>
                          </span>
                        </el-tooltip>
                        <el-tooltip :content="projectTitle + '-' + projectID + '-' + 'Inspiration'" placement="top-start" effect="light" >
                          <span class="darkblue center">{{ projectTitle + '-' + projectID + '-' + 'Inspiration' }}</span>
                        </el-tooltip>
                      </div>
                  </div>
                <!-- eslint-enable -->
              </div>
            <!-- <div class="mt3 flex flex-column md-col-2 lg-col-2 sm-col-2 xs-col-7 items-center pointer" @click="opentenderqa()" v-if="selectedFolder !== 'Public'">
              <span class="darkblue">
                <svg xmlns="http://www.w3.org/2000/svg" width="65.547" height="75" viewBox="0 0 65.547 75">
                  <path id="Path_4061" data-name="Path 4061" d="M5876.205-238a9.224,9.224,0,0,1-2.085-.241.292.292,0,0,0-.047-.011c-.175-.044-.354-.093-.543-.15,0,0,0,0-.006,0a.227.227,0,0,1-.044-.014.227.227,0,0,0-.041-.011l-.188-.063c-.088-.03-.178-.063-.266-.1h0l-.037-.016a.407.407,0,0,0-.053-.019c-.186-.071-.354-.145-.52-.219,0,0,0,0,0,0s0,0-.006,0c-.146-.068-.3-.148-.473-.24a.494.494,0,0,1-.057-.033c-.02-.011-.039-.019-.061-.03-.137-.077-.273-.156-.4-.235a.2.2,0,0,0-.029-.022l-.047-.025c-.15-.1-.3-.2-.448-.309-.016-.011-.029-.025-.046-.036s-.036-.025-.053-.038h0c-.115-.085-.229-.175-.339-.265l-.044-.041a.836.836,0,0,1-.071-.057h0a0,0,0,0,0,0,0c-.046-.038-.092-.079-.137-.118-.1-.085-.183-.167-.265-.246l-5.9-5.66a0,0,0,0,0,0,0s0,0,0,0c-.112-.109-.228-.227-.356-.363h-3.232a6.4,6.4,0,0,1-6.393-6.39V-306.61a6.4,6.4,0,0,1,6.393-6.39h35.533a6.4,6.4,0,0,1,6.39,6.39v.519h2.384a4.8,4.8,0,0,1,4.8,4.794v25.922a34.352,34.352,0,0,1,8.806,6.764,4.709,4.709,0,0,1,0,6.381,34.317,34.317,0,0,1-8.806,6.764v12.673a4.8,4.8,0,0,1-4.8,4.794Zm-12.1-23.145v8.355c0,.087,0,.178,0,.268,0,.03,0,.06.006.09,0,.06.008.117.014.178v.022h7.926a3.825,3.825,0,0,1,3.82,3.821v7.475c.109.005.216.008.325.008H5904.7a1.868,1.868,0,0,0,1.866-1.864h0v-11.3q-1.226.5-2.484.894l-.18.057c-.129.038-.258.079-.389.115s-.268.079-.4.115c-.1.027-.2.057-.3.085-.2.052-.4.1-.6.153l-.159.038a30.44,30.44,0,0,1-9.554.752l-.15-.011-.521-.049-.29-.03c-.106-.011-.216-.025-.322-.038-.252-.03-.5-.066-.749-.1l-.077-.011a30.931,30.931,0,0,1-7.692-2.192c-.039-.016-.079-.033-.12-.052-.161-.071-.323-.142-.484-.216l-.161-.074c-.47-.216-.932-.443-1.392-.683-.1-.052-.2-.1-.295-.156s-.221-.117-.33-.178l-.336-.189c-.1-.055-.2-.112-.3-.169-.143-.082-.287-.167-.429-.254l-.2-.12c-.205-.126-.41-.254-.613-.383-.067-.044-.137-.087-.2-.134-.147-.093-.295-.191-.439-.29-.071-.046-.145-.1-.216-.145-.151-.1-.3-.208-.452-.314-.057-.041-.114-.082-.174-.123-.208-.15-.413-.3-.617-.454a.247.247,0,0,0-.036-.027q-.287-.217-.573-.443c-.059-.044-.113-.09-.17-.137-.148-.118-.3-.238-.443-.358-.06-.049-.12-.1-.177-.15-.165-.134-.326-.273-.484-.413-.035-.03-.074-.06-.109-.093-.193-.172-.388-.344-.582-.522-.043-.038-.085-.079-.128-.12-.151-.137-.3-.276-.443-.415-.06-.057-.12-.117-.184-.175-.134-.131-.267-.262-.4-.4-.058-.055-.112-.112-.169-.167-.184-.189-.367-.374-.548-.566a4.709,4.709,0,0,1,0-6.381c.181-.191.364-.38.548-.566.057-.057.111-.112.169-.167.132-.134.265-.265.4-.4l.184-.175c.147-.142.292-.279.44-.415.046-.041.088-.082.131-.12.194-.178.389-.353.582-.522.038-.033.074-.063.109-.1.161-.137.319-.276.481-.41l.18-.15c.147-.12.295-.238.44-.358.06-.046.117-.09.175-.137.188-.15.377-.3.568-.44l.039-.03c.2-.153.409-.3.617-.454.06-.041.117-.082.177-.126l.446-.312.221-.148.432-.287c.071-.044.141-.09.208-.134.2-.131.408-.257.613-.383.067-.044.139-.082.21-.126.139-.085.278-.167.418-.249l.3-.172c.108-.063.221-.123.33-.183s.224-.123.34-.183c.092-.052.185-.1.28-.15.465-.243.933-.473,1.407-.691l.151-.068c.163-.074.327-.148.492-.219l.111-.049a31.034,31.034,0,0,1,7.7-2.192c.025-.005.053-.008.077-.014.252-.035.5-.068.755-.1.106-.014.21-.027.316-.038s.194-.022.29-.03c.174-.019.347-.033.52-.049.051,0,.1-.008.155-.014a30.454,30.454,0,0,1,9.543.752c.058.014.117.027.175.044.189.044.375.093.563.142l.363.1c.12.033.241.068.358.1l.407.123c.049.016.1.03.149.046q1.269.4,2.507.9V-301.3a1.868,1.868,0,0,0-1.866-1.864h-38.726a1.866,1.866,0,0,0-1.864,1.864v28.433a1.465,1.465,0,0,1-1.466,1.465,1.464,1.464,0,0,1-1.464-1.465V-301.3a4.8,4.8,0,0,1,4.794-4.794h33.412v-.519a3.464,3.464,0,0,0-3.46-3.46h-35.533a3.465,3.465,0,0,0-3.463,3.46v53.648a3.465,3.465,0,0,0,3.463,3.46h1.4c-.016-.038-.029-.077-.043-.115-.022-.057-.041-.112-.063-.169a.066.066,0,0,0-.008-.022v0a.16.16,0,0,1-.008-.027c-.011-.03-.021-.063-.031-.093,0,0,0,0,0,0-.014-.044-.024-.087-.038-.128s-.035-.109-.052-.164c-.006-.022-.012-.041-.018-.06-.019-.06-.032-.12-.048-.178-.009-.033-.02-.066-.027-.1-.028-.115-.056-.229-.08-.347,0-.005,0-.011,0-.019-.021-.107-.042-.216-.061-.325-.006-.036-.011-.074-.017-.109-.014-.079-.026-.159-.038-.241,0-.041-.011-.085-.013-.126-.01-.077-.018-.153-.025-.23,0-.041-.009-.085-.011-.126-.006-.082-.011-.161-.017-.243,0-.036,0-.074-.006-.112,0-.117,0-.232,0-.35v-8.355a1.464,1.464,0,0,1,1.464-1.465A1.465,1.465,0,0,1,5864.109-261.145Zm1.314,12.17,0,.005c.011.016.022.03.033.044a.291.291,0,0,1,.025.03c.062.074.125.148.188.221.016.016.026.033.04.049l.033.033c.1.107.183.194.265.273l5.9,5.663c.049.047.1.1.161.15.035.03.073.063.117.1a.169.169,0,0,0,.033.03c.014.014.029.022.043.036.077.063.156.123.235.183.012.008.022.019.036.03a.163.163,0,0,1,.026.019c.1.074.205.142.307.208l.016.011a.148.148,0,0,0,.036.019l.027.016v-6.556a.891.891,0,0,0-.891-.891h-6.873C5865.262-249.191,5865.342-249.082,5865.424-248.975Zm18.768-16.447a10.716,10.716,0,0,0,10.7,10.7,10.717,10.717,0,0,0,10.7-10.7,10.716,10.716,0,0,0-10.7-10.7A10.715,10.715,0,0,0,5884.191-265.422Zm24.337,0a13.574,13.574,0,0,1-3.075,8.617q.93-.381,1.851-.834a31.178,31.178,0,0,0,8.865-6.6,1.809,1.809,0,0,0,0-2.359,31.171,31.171,0,0,0-8.877-6.608c-.147-.074-.3-.148-.445-.216a.082.082,0,0,1-.021-.011c-.454-.213-.913-.413-1.372-.6A13.572,13.572,0,0,1,5908.528-265.422Zm-31.266-4.5a.639.639,0,0,1-.058.044c-.123.1-.245.194-.365.292l-.181.148c-.106.087-.213.175-.319.265-.083.068-.165.139-.247.208s-.175.15-.262.229q-.246.213-.486.435c-.063.057-.123.115-.187.172-.114.107-.229.213-.341.322-.063.06-.124.12-.187.18-.12.115-.238.232-.358.353-.048.049-.1.1-.152.15-.167.172-.334.344-.5.519a1.726,1.726,0,0,0-.437,1.178,1.746,1.746,0,0,0,.337,1.058,1.205,1.205,0,0,0,.1.123c.163.172.33.344.5.514l.164.164c.114.115.229.227.345.339l.2.189c.107.1.216.2.325.309.068.063.134.126.2.186.155.142.312.284.474.424.092.085.19.164.283.246l.23.2c.109.09.218.183.327.273.058.044.112.09.17.137.123.1.248.2.374.3.017.011.03.022.044.033a29.843,29.843,0,0,0,7.084,4.124,13.553,13.553,0,0,1-3.074-8.611,13.558,13.558,0,0,1,3.074-8.611A30.007,30.007,0,0,0,5877.263-269.917Zm10.21,4.5a7.431,7.431,0,0,1,7.423-7.42,7.428,7.428,0,0,1,7.42,7.42A7.429,7.429,0,0,1,5894.9-258,7.431,7.431,0,0,1,5887.473-265.422Zm2.93,0a4.5,4.5,0,0,0,4.493,4.493,4.5,4.5,0,0,0,4.49-4.493,4.5,4.5,0,0,0-4.49-4.49A4.5,4.5,0,0,0,5890.4-265.422Zm-28.045-.145a1.521,1.521,0,0,1-.273-.085,1.452,1.452,0,0,1-.255-.134,1.5,1.5,0,0,1-.224-.183,1.479,1.479,0,0,1-.181-.221,1.454,1.454,0,0,1-.133-.254,1.35,1.35,0,0,1-.085-.273,1.433,1.433,0,0,1-.03-.287,1.455,1.455,0,0,1,.03-.287,1.407,1.407,0,0,1,.085-.273,1.531,1.531,0,0,1,.133-.251,1.5,1.5,0,0,1,.181-.224,1.486,1.486,0,0,1,1.323-.4,1.228,1.228,0,0,1,.275.085,1.452,1.452,0,0,1,.252.131,1.677,1.677,0,0,1,.222.183,1.4,1.4,0,0,1,.184.224,1.546,1.546,0,0,1,.136.251,1.63,1.63,0,0,1,.082.273,1.455,1.455,0,0,1,.03.287,1.433,1.433,0,0,1-.03.287,1.555,1.555,0,0,1-.082.273,1.466,1.466,0,0,1-.136.254,1.385,1.385,0,0,1-.184.221,1.487,1.487,0,0,1-.222.183,1.46,1.46,0,0,1-.252.134,1.517,1.517,0,0,1-.275.085,1.428,1.428,0,0,1-.285.027A1.459,1.459,0,0,1,5862.357-265.567Zm8.945-13.156a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h7.972a1.465,1.465,0,0,1,1.467,1.465,1.465,1.465,0,0,1-1.467,1.465Zm0-8.057a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h18.641a1.465,1.465,0,0,1,1.465,1.465,1.465,1.465,0,0,1-1.465,1.465Zm0-8.057a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h25.782a1.465,1.465,0,0,1,1.465,1.465,1.465,1.465,0,0,1-1.465,1.465Z" transform="translate(-5854 313)" fill="#003645"/>
                </svg>
              </span>
              <span class="center">Spørgsmål og svar</span>
            </div> -->
        </div>
        <!-- Tender File Q and A -->
      <b-modal id="tenderQA" hide-footer hide-header size="lg" centered lazy v-model="tenderQA" ref="tenderQA" class="p-2 pb-4" no-close-on-backdrop no-close-on-esc>
        <div class="col-12 flex justify-end items-center white-background px0 ">
          <button type="button" class="white-button no-border not-rounded gibson " @click="closetenderqa()">
            <span> <i class="el-icon-circle-close"></i> </span>
          </button>
        </div>
        <div class="flex xs-flex-column darkblue">
          <div class="flex flex-column lg-col-7 md-col-7 xs-col-12 p0">
            <div class="clearfix" v-if="formLoading">
              <Loading></Loading>
            </div>
            <div class="p2 overflow-auto projectdesccontainer" v-else>
              <div class="col-12 p0 m0 flex">
                <span class="h5 bold darkblue">Beskrivelse</span>
                <div class="ml-auto">
                  <span><i class="el-icon-printer pointer"></i></span>
                  <span><i class="el-icon-download pointer"></i></span>
                </div>
              </div>
              <!-- eslint-disable -->
              <div class="bordercece py3 px1">
                <div class=" mb2" v-for="(item,index) in productlistforpricearr" :key="index" v-if="item.jobindustry">
                  <p class="h5 p0 m0 mb1">{{(index + 1) + '. '}}<span class="semi-bold">{{primaryproductindustryname[parseInt(item.industryid)]}}</span></p>
                  <div class="flex flex-column p0 "  v-for="(job,index2) in Object.entries(item.industrydetails)" :key="index2">
                    <p class="h5 p0 m0 mb1 pl2">{{(index + 1) + '.' + (index2 + 1)}}<span class="regular pl1">{{itemsjobindustry[job[0]]}}</span></p>
                    <div class="" v-for="(desc,index3) in item.industrydetails[job[0]]" :key="index3">
                      <div class="flex m0 pl3 deschover">
                        <div class="pointer flex descreptionline flex lg-col-12 sm-col-12 md-col-12 xs-col-11 p0 m0" @click="addastags(item.industryid, job[0], index3, desc)">
                          <div class="p0 m0 h6 line-height-golden graymuteddark col-1 mr2">{{parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)}}</div>
                          <div class="pl2 p0 m0 h6 line-height-golden graymuteddark ">{{desc.replace('- ', '')}}</div>
                        </div>
                        <div :id="index3" class="ml-auto addquestionicon pr1" v-if="!showMobile">
                          <el-tooltip class="item" effect="dark" :content="Number(getnoreplybydescId(index3, item.industryid, job[0])) > 1 ? getnoreplybydescId(index3, item.industryid, job[0]) + ' answers' : getnoreplybydescId(index3, item.industryid, job[0]) + ' answer'" placement="top">
                            <span class="pointer" @click="selectDescIndustry(item.industryid, index3, job[0])" v-if="Number(getnoreplybydescId(index3, item.industryid, job[0]) > 0)">
                              <i class="h5 el-icon-chat-line-square"></i>
                            </span>
                          </el-tooltip>
                          <!-- <el-tooltip class="item" effect="dark" content="Add question" placement="top-start">
                            <i class="el-icon-chat-dot-square pointer" @click="addastags(item.industryid, job[0], index3)"></i>
                          </el-tooltip> -->
                        </div>
                        <span :id="index3" class="ml-auto addquestionicon pr1" v-else-if="questions === '' && showMobile">
                          <el-tooltip class="item" effect="dark" content="View replies" placement="top">
                            <span class="small pointer" @click="selectDescIndustry(item.industryid, index3, job[0])" v-if="Number(getnoreplybydescId(index3, item.industryid, job[0]) > 0)">{{Number(getnoreplybydescId(index3, item.industryid, job[0])) > 1 ? getnoreplybydescId(index3, item.industryid, job[0]) + ' answers' : getnoreplybydescId(index3, item.industryid, job[0]) + ' answer'  }}</span>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="Add question" placement="top-start">
                            <i class="el-icon-chat-dot-square pointer" @click="addastags(item.industryid, job[0], index3)"></i>
                          </el-tooltip>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- eslint-enable -->
            </div>
          </div>
          <div class="p2 boder md-col-5 lg-col-5 xs-col-12 pb3">
            <div class="">
                <div class="m0 p0 mp0 lg-col-12 md-col-12 sm-col-12">
                  <p class="h5 semi-bold">Tilføj Spørgsmål</p>
                  <el-form>
                  <el-select v-model="productTags" @change="autoselectdescID()" multiple filterable :multiple-limit="1" placeholder="Tags" class="col-12 p0 capital border tagSelect mb1">
                    <el-option
                      v-for="(item,index) in tagsData"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="descIndex" @change="autoselectdescID()" multiple filterable :multiple-limit="1" placeholder="Beskrivelse" class="col-12 p0 capital border mb1" v-if="productTags.length > 0">
                    <el-option
                      v-for="(items,index) in selectiondescriptionObj[productTags[0]]"
                      :key="index"
                      :label="items"
                      :value="index">
                    </el-option>
                  </el-select>
                  <!-- <div class="notosans darkblue flex justify-start p0 m0" v-if="seletecddescline !== ''">
                    <p class="m0 p0 regular">{{seletecddescline}}</p>
                  </div> -->
                  <el-form-item label="" prop="questions" class="border-none p0 ">
                      <el-input type="textarea" :rows="3" v-model="questions" class="border wizard-border white-background" placeholder="Spørgsmål"></el-input>
                  </el-form-item>
                  </el-form>
                </div>
                <div class="col-12 flex p0">
                <button class="dark-button p2 px3 not-rounded ml-auto" :disabled="disableaddbutton" @click="addquestion()">Tilføj spørgsmål</button>
                </div>
            </div>
            <!-- eslint-disable -->
            <div class="flex justify-end p0 m0 mt3 items-center">
              <p class="p0 small m0 pointer px1" @click="refresh()"><el-tooltip class="item" effect="dark" content="Refresh" placement="top"><span class="m0 p0">Refresh</span></el-tooltip></p>
              <p class="p0 m0 small pointer" @click="showall()" v-if="defaultallquestionsanswerArr.length !== allquestionsanswerArr.length && allquestionsanswerArr.length > 0">Show All</p>
            </div>
            <div class="overflow-auto pt1" :class="defaultallquestionsanswerArr.length > 0 && allquestionsanswerArr.length < 1 ? 'border muted-border ' : null" style="height:483px;">
              <div class="flex flex-column justify-center">
                <div class="clearfix" v-if="innerloading">
                  <Loading></Loading>
                </div>
                <div v-else>
                
                <div class="mb1" v-for="(questions,index) in allquestionsanswerArr" :key="index" v-if="allquestionsanswerArr.length > 0 && submittedIndustries.includes(questions.UF_JOB_INDUSTRY_ID)">
                  <div class="p2 questiondiv flex flex-column">
                    <div class="pb1" v-if="Number(haaId) === questions.UF_PARTNER_ID"> <p class="m0 h6 semi-bold"> Du - {{partnerprimaryindustryText}}</p></div>
                    <div class="pb1" v-else-if="questions.UF_MESSAGE_FROM === Number(contactID)"> <p class="m0 h6 semi-bold"> Husejer </p></div>
                    <div class="" v-else> <p class="m0">Haandvaerker</p></div>
                    <div class="flex flex-wrap p0 m0">
                      <div class="industryquestionsdiv px1 questionsgray flex p0 m0 items-center mb1 mr1" v-for="industry in questions.INDUSTRY">
                        <p class="m0 p0 lowercase font14">{{(industry.NAME)}} - {{itemsjobindustry[questions.UF_JOB_INDUSTRY_ID]}}</p>
                      </div>
                    </div>
                    <div class="p0 m0"><p class="m0 font14 questionsgray">{{questions.UF_MESSAGE}}</p></div>
                    <div class="flex p0 m0 small mt2">
                      <p class="m0 font14">{{questions.TOTAL_REPLY}} Samlet svar</p>
                      <p class="m0 ml-auto font14 pointer" v-if="questions.TOTAL_REPLY > 0" @click="viewanswers(index, questions.ID)">Se svar</p>
                      <p class="m0 ml-auto font12 pointer" v-else @click="addchildreplay(questions.ID)">Svar</p>
                    </div>
                  </div>
                  <div class="ml2 py1 pr0 pl2 flex flex-column font14 relative" v-if="questions['childquestionsanswers'].length > 0">
                    <div class="questiondiv p2" v-for="otherchild in questions['childquestionsanswers']">
                      <p class="m0 primarycolor" v-if="otherchild.UF_MESSAGE_FROM === Number(contactID)">Husejer</p>
                      <p class="m0 primarycolor" v-else-if="otherchild.UF_MESSAGE_FROM === Number(haaId)">Du</p>
                      <p class="m0 darkblue">{{otherchild.UF_MESSAGE}}</p>
                    </div>
                      <p class="m0 absolute bottom-0 right-0 px2 pointer font12" style="bottom: -13px;" @click="addchildreplay(questions.ID)">Svar</p>
                  </div>
                  <div :id="'reply' + questions.ID" class="ml2 p2 my1 flex hide">
                    <el-input type="textarea" :rows="1" v-model="replayanswer" class="border wizard-border white-background" placeholder="Spørgsmål"></el-input>
                    <button class="small action-button pointer" @click="addreplytoanswers(questions.ID, index)">Indsend</button>
                    <button class="small outlined-standard-button pointer" @click="hidechildreply(index, questions.ID)">Afbestille</button>
                  </div>
                </div>
                    </div>
                  </div>
              </div>
            <!-- eslint-enable -->
          </div>
        </div>
      </b-modal>
      <b-modal  centered hide-header hide-footer id="downloadpdf" size="lg" ref="downloadpdf">
        <div class="col-12 flex justify-end items-center white-background px0 ">
          <button type="button" class="white-button no-border not-rounded gibson " @click="closepdfdownload()">
            <span> <i class="el-icon-circle-close"></i> </span>
          </button>
        </div>
        <div class="clearfix" v-if="showloadingpdf">
          <Loading></Loading>
        </div>
        <div class="py1 col-12 p0 relative" style="width:100%;overflow:auto;" v-else>
        <div class="col-9 p0 mx-auto">
          <!-- <b-embed type="iframe" scrolling="no" :src="selectedtender" aspect="1by1"  allowfullscreen ></b-embed> -->
          <!-- <ejs-pdfviewer  id="pdfViewer" ref="pdfviewer" :serviceUrl="serviceUrl"  :enableToolbar="false" height="800px" > </ejs-pdfviewer> -->
          <vue-pdf-app :pdf="pdfStr" theme="light" :page-scale="scale" style="height: 100vh;" :config="config" @pages-rendered="pagesRenderedHandler"></vue-pdf-app>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-xl" size="xl" v-model="showPdf" centered hide-header hide-footer>
          <b-embed type="iframe" aspect="16by9" :src="pdfLink" allowfullscreen></b-embed>
      </b-modal>
      <ErrorHandler ref="errorMsg"></ErrorHandler>
    </div>
</template>

<script>
import VuePdfApp from 'vue-pdf-app'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  components: {
    Loading,
    ErrorHandler,
    VuePdfApp
  },
  data () {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      projectID: '',
      contactID: '',
      haaId: '',
      salesPersonbitrix: '',
      tenderFolderID: '',
      formLoading: false,
      searchQuery: '',
      documentsData: [],
      defaultFolderId: '',
      parentFolderData: [],
      currentFolderId: '',
      currentFolderParentId: '',
      currentProjectInfo: {},
      selectedtender: '',
      projectAddress: '',
      tenderQA: false,
      productlistforpricearr: [],
      primaryproductindustryname: {},
      tagsData: [],
      productTags: [],
      questions: '',
      projectTitle: '',
      allquestionsanswerArr: [],
      defaultallquestionsanswerArr: [],
      disableaddbutton: false,
      selectedIndustryDesc: {
        industryid: '',
        industrydesc: ''
      },
      showloadingpdf: false,
      innerloading: false,
      replayanswer: '',
      alldescriptionidwithreply: [],
      viewer: {},
      serviceUrl: '',
      partnerName: '',
      documentPath: '',
      publicFiles: [],
      seletecdfolder: 'default',
      parent_tenderID: '',
      selectedFolder: '',
      insideFolder: '',
      showPdf: false,
      pdfLink: '',
      tenderfilesOffer: {},
      tenderfilesInspiration: {},
      itemsjobindustry: {},
      showMobile: false,
      partnerprimaryindustryText: '',
      tenderFiles: [],
      childprojects: [],
      partnerjobindustry: [],
      jobList: [],
      submittedIndustries: [],
      parentprojectID: '',
      contractType: '',
      seletecddescline: '',
      scale: 120,
      config: {
        toolbar: {
          toolbarViewerLeft: false
        }
      },
      pdfStr: '',
      activepage: 1,
      tenderOfferFiles: [],
      tenderInspirationFiles: [],
      selectiondescriptionObj: {},
      descIndex: 0,
      offerStatus: ''
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  mounted () {
    // Fagentreprise
    // Hovedentreprise
    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer'
    this.partnerprimaryindustryText = localStorage.getItem('partnerPrimaryIndustryText')
    this.projectID = this.$route.query.projectID
    this.parentprojectID = this.$route.query.parentprojectID
    this.contractType = this.$route.query.contracttype
    this.contactID = this.$route.query.contact_id
    this.offerStatus = this.$route.query.offerstatus
    this.tenderFolderID = this.$route.query.tenderFolderID
    this.parent_tenderID = this.$route.query.parent_tenderID
    this.jobList = JSON.parse(this.$route.query.joblist)
    this.projectTitle = this.$route.query.title
    this.partnerName = localStorage.getItem('name')
    this.projectAddress = this.$route.query.address
    this.haaId = localStorage.getItem('haaid')
    this.childprojects = JSON.parse(this.$route.query.childprojects)
    // this.childprojects.forEach(o => {
    //   if (o.IS_OFFER_ACCEPTED && o.IS_PARTNER) {
    //     this.jobindustry.push(o.JOB_INDUSTRY)
    //   }
    // })
    this.jobList.forEach(k => {
      if (Array.isArray(k)) {
        k.forEach(k => {
          var jobindustry = k.split(':')[0]
          this.submittedIndustries.push(jobindustry.toString())
        })
      } else {
        var jobindustry = k.split(':')[0]
        this.submittedIndustries.push(jobindustry.toString())
      }
    })
    this.tenderFiles = JSON.parse(this.$route.query.tenderfiles)
    this.tenderOfferFiles = this.tenderFiles.filter(i => { return i.TYPE === 'offer' && i.PARTNER_ID === Number(this.haaId) })
    this.tenderInspirationFiles = this.tenderFiles.filter(i => { return i.TYPE === 'inspiration' })
    this.getallwizardproduct()
    this.gettaskbitrix()
    this.getQuestionsAnswers()
    this.displaytenderFiles(this.parent_tenderID)
    this.getPublicFiles()
    this.tenderFolders()
    // this.displayOfferfile()
    // this.runmainwebviewer()
  },
  methods: {
    // runmainwebviewer () {
    folderChange (currentFolderId, currentFolderName, currentFolderParentId, index, type) {
      this.selectedFolder = currentFolderName
      this.insideFolder = type
      this.parentFolderData = []
      this.parentFolderData.push({
        folderId: '',
        folderName: 'Main'
      })
      if (type === 'in') {
        this.parentFolderData.push({
          folderId: currentFolderId,
          folderName: currentFolderName
        })
      } else {
        for (var i = 0; i < this.parentFolderData.length; i++) {
          if (i > index) {
            this.parentFolderData.splice(i, 1)
            i--
          }
        }
      }
    },
    tenderFolders () {
      var tenderOffer = this.tenderFiles.filter((property) => {
        return property.TYPE === 'offer'
      })
      var tenderInspiration = this.tenderFiles.filter((property) => {
        return property.TYPE === 'inspiration'
      })
      this.tenderfilesOffer = tenderOffer[0]
      this.tenderfilesInspiration = tenderInspiration[0]
    },
    showPdfFile (link) {
      this.pdfLink = link
      this.showPdf = true
    },
    loadingFolder () {
      this.loading = true
      this.displaytenderFiles()
    },
    truncate (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    },
    displaytenderFiles (folderId) {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(process.env.BITRIXAPI + 'partner/folder/' + folderId + '/children', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          // var filteredfiles = res.data.filter(p => { return p.TYPE === 'file' })[0]
          // this.documentsData.push(filteredfiles)
          // var filteredfolders = res.data.filter(p => { return p.TYPE !== 'file' })
          // filteredfolders.forEach(k => {
          //   this.documentsData.push(k)
          // })
          this.documentsData = res.data
          this.documentsData.forEach((k, index) => {
            if (k.TYPE !== 'folder') {
              this.convertLinktoPDF(k.DOWNLOAD_URL, index, 'tenderFile', this.documentsData)
            }
          })
          this.loading = false
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    async tenderviewv2 (tenderitem) {
      const response = await fetch(tenderitem.DOWNLOAD_URL)
      const data = await response.blob
      return new File([data], tenderitem.NAME, {
        type: data.type || 'application/pdf'
      })
    },
    convertLinktoPDF (link, index, typefile, array, external = '') {
      return new Promise((resolve, reject) => {
        this.haaid = localStorage.getItem('haaid')
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
          type: 'pdf',
          url: link
        }
        this.$http.post(this.$bitrixapi + 'external/helper/encodeToBase64', data, { headers }, { emulateJSON: true }).then(
          response => {
            var res = response.body.data
            if (external === 'external') {
              resolve('data:application/pdf;base64,' + res)
            } else {
              array[index]['pdfbase64'] = 'data:application/pdf;base64,' + res
              if (parseInt(this.documentsData.length - 1) === index) {
                this.loading = false
              }
            }
          },
          response => {
            var error = response.body
            this.$refs.errorMsg.showMsg(error)
          })
      })
    },
    // tenderview (tenderitem) {
    //   this.loading = true
    //   // var tendername = tenderitem ? tenderitem.NAME.replace('Tender_', '').replace('.pdf', '') : ''
    //   // this.selectedtender = tenderitem.DOWNLOAD_URL
    //   var thisvar = this
    //   var pdfdownloadlink = ''
    //   var request = new XMLHttpRequest()
    //   request.open('GET', tenderitem.DOWNLOAD_URL, true)
    //   // request.headers = {'Access-Control-Allow-Origin': *}
    //   request.responseType = 'blob'
    //   request.onload = function () {
    //     var reader = new FileReader()
    //     reader.readAsDataURL(request.response)
    //     reader.onload = function (e) {
    //       pdfdownloadlink = e.target.result
    //       thisvar.openpdfdownload(pdfdownloadlink)
    //     }
    //   }
    //   request.send()
    // },
    ajaxRequestFailure (args) {
      window.location.reload()
    },
    async openpdfdownload (tenderitem) {
      var newlink = ''
      if (tenderitem.includes('ordrapport.miljoeportal.dk') || (tenderitem.includes('.pdf') && !tenderitem.includes('tender'))) {
        this.showPdfFile(tenderitem)
      } else if (tenderitem.includes('https://weblager.dk/rest/buildingproject/download')) {
        this.$refs.downloadpdf.show()
        this.showloadingpdf = true
        newlink = await this.convertLinktoPDF(tenderitem, 0, 'pdf', [], 'external')
        setTimeout(() => {
          this.pdfStr = newlink
          this.loading = false
          this.showloadingpdf = false
          // this.viewer = document.getElementById('pdfViewer').ej2_instances[0]
          // this.viewer.load(newlink, null)
          // this.viewer.annotationSettings = { author: this.partnerName }
        }, 500)
      } else if (tenderitem.includes('public.filarkiv.dk/Document') || tenderitem.includes('dingeo.dk/adresse') || tenderitem.includes('dingeo.dk/byggesag')) {
        window.open(tenderitem, '_blank')
      } else {
        this.$refs.downloadpdf.show()
        this.showloadingpdf = true
        if (tenderitem.includes('data:application/pdf;base64')) {
          newlink = tenderitem
        } else {
          newlink = await this.convertLinktoPDF(tenderitem, 0, 'pdf', [], 'external')
        }
        this.pdfStr = newlink
        this.showloadingpdf = false
        // setTimeout(() => {
        //   this.showloadingpdf = true
        //   // this.viewer = document.getElementById('pdfViewer').ej2_instances[0]
        //   // this.viewer.load(tenderitem, null)
        //   // this.viewer.annotationSettings = { author: this.partnerName }
        //   this.loading = false
        // }, 200)
      }
    },
    closepdfdownload () {
      this.$refs.downloadpdf.hide()
    },
    opentenderqa () {
      this.getProductList()
      this.tenderQA = true
    },
    closetenderqa  () {
      this.tenderQA = false
    },
    getProductList () {
      this.productlistforpricearr = []
      var projectid = this.contractType === 'Hovedentreprise' ? this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062' ? this.parentprojectID : this.projectID : this.parentprojectID
      this.formLoading = true
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + projectid + '&contact_id=' + this.contactID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          for (var index in res) {
            var enterpiserdata = {}
            enterpiserdata['industryid'] = index
            enterpiserdata['industrydetails'] = {}
            for (var jobindustry in res[index]) {
              this.selectiondescriptionObj[index + '-' + jobindustry] = []
              if (this.submittedIndustries.includes(jobindustry) && jobindustry !== '1062') {
                enterpiserdata['jobindustry'] = jobindustry
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry]
                this.tagsData.push({label: this.primaryproductindustryname[index] + ' - ' + this.itemsjobindustry[jobindustry], value: index + '-' + jobindustry, key: index})
              } else if (this.submittedIndustries.includes(jobindustry) && this.submittedIndustries.length === 1 && jobindustry === '1062') {
                enterpiserdata['jobindustry'] = jobindustry
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry]
                this.tagsData.push({label: this.primaryproductindustryname[index] + ' - ' + this.itemsjobindustry[jobindustry], value: index + '-' + jobindustry, key: index})
              }
              this.selectiondescriptionObj[index + '-' + jobindustry] = res[index][jobindustry]
            }
            this.productlistforpricearr.push(enterpiserdata)
          }
          this.formLoading = false
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    gettaskbitrix () {
      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var industryname = {}
            res.data.forEach(l => {
              industryname[l.BRANCHE_ID] = l.BRANCHE
            })
            this.itemsjobindustry = industryname
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getPublicFiles () {
      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID
      this.haaid = localStorage.getItem('haaid')
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid + '/getAddresPublicFiles', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.publicFiles = res
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    getallwizardproduct () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          res.forEach(n => {
            this.primaryproductindustryname[n.producttypeid] = n.producttype
          })
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    getnoreplybydescId (descid, enterpriseId, jobindystry) {
      var nodescid = []
      nodescid = this.defaultallquestionsanswerArr.filter(l => {
        return l.UF_DESCRIPTION_ID === jobindystry + '-' + descid && l.UF_INDUSTRY_ID === enterpriseId
      })
      return nodescid[0] ? nodescid[0]['TOTAL_REPLY'] : 0
    },
    getQuestionsAnswers () {
      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid + '/getAllQuestions', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.defaultallquestionsanswerArr = res
          this.allquestionsanswerArr = res
          res.forEach((k, index) => {
            this.allquestionsanswerArr[index]['childquestionsanswers'] = []
            this.alldescriptionidwithreply.push(k.UF_DESCRIPTION_ID)
          })
          this.innerloading = false
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    selectDescIndustry (industryID, index, jobindustry = 0) {
      this.selectedIndustryDesc['industryid'] = industryID
      this.selectedIndustryDesc['industrydesc'] = jobindustry + '-' + index
      this.updatequestionsView(jobindustry + '-' + index, industryID)
    },
    showall () {
      this.allquestionsanswerArr = this.defaultallquestionsanswerArr
    },
    seeTenderpublic () {
      console.log('asdasd')
    },
    addastags (industryID, jobindustry, descindex, descitem = '') {
      this.productTags = []
      this.descIndex = []
      this.disableaddbutton = false
      if (!this.productTags.includes(industryID + '-' + jobindustry)) {
        this.productTags.push(industryID + '-' + jobindustry)
      }
      this.seletecddescline = descitem
      this.descIndex.push(descindex)
      this.selectedIndustryDesc['industrydesc'] = jobindustry + '-' + descindex
    },
    autoselectdescID () {
      var selecteditem = this.productTags[0]
      var selecteditemdesc = this.descIndex[0]
      this.selectedIndustryDesc['industrydesc'] = selecteditem.split('-')[1] + '-' + selecteditemdesc
    },
    pagesRenderedHandler (pdfapp) {
      this.pdf = pdfapp
      this.activepage = pdfapp.page
      var thisvar = this
      this.pdf.bindEvents('pagechanging', (a) => {
        thisvar.page = a.page
      })
    },
    addquestion () {
      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID
      if (this.questions === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst spørgsmål'
        })
        return false
      }
      var tags = this.productTags.join(',')
      this.disableaddbutton = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        industryId: tags,
        descriptionId: this.selectedIndustryDesc['industrydesc'],
        contactId: this.contactID,
        question: this.questions,
        jobIndustryId: this.selectedIndustryDesc['industrydesc'] ? this.selectedIndustryDesc['industrydesc'].split('-')[0] : '0'
      }
      this.$http.post(this.$bitrixapi + 'partner/project/' + projectid + '/addQuestion', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.questions = ''
          this.productTags = []
          this.disableaddbutton = false
          this.seletecddescline = ''
          this.selectedIndustryDesc['industryid'] = ''
          this.selectedIndustryDesc['industrydesc'] = ''
          this.getQuestionsAnswers()
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    refresh () {
      this.innerloading = true
      this.getQuestionsAnswers()
    },
    viewanswers (index, parentid) {
      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID
      this.innerloading = true
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid + '/getQuestion/' + parentid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.allquestionsanswerArr[index]['childquestionsanswers'] = res
          this.innerloading = false
          // this.hidechildreply(index, parentid)
        },
        err => {
          var error = err.body.message
          this.$message.error(error)
        })
    },
    addchildreplay (divid) {
      console.log('🚀 ~ file: tenderFolder.vue:428 ~ addchildreplay ~ divid', divid)
      var inputdiv = document.getElementById('reply' + divid.toString())
      inputdiv.classList.remove('hide')
    },
    hidechildreply (index, parentid) {
      this.replayanswer = ''
      var inputdiv = document.getElementById('reply' + parentid.toString())
      inputdiv.classList.add('hide')
    },
    addreplytoanswers (parentId, parentindex) {
      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID
      if (this.replayanswer === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst spørgsmål'
        })
        return false
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        parentId: parentId,
        message: this.replayanswer
      }
      this.$http.post(this.$bitrixapi + 'partner/project/' + projectid + '/replyQuestion', data, { headers }, { emulateJSON: true }).then(
        response => {
          this.productTags = []
          this.replayanswer = ''
          this.disableaddbutton = false
          this.selectedIndustryDesc['industryid'] = ''
          this.selectedIndustryDesc['industrydesc'] = ''
          this.viewanswers(parentindex, parentId)
        },
        err => {
          var error = err.body.data
          this.$message.error(error)
        })
    },
    updatequestionsView (descId, enterpriseId) {
      var filteredquestions = []
      filteredquestions = this.defaultallquestionsanswerArr.filter(l => {
        return l.UF_DESCRIPTION_ID === descId && l.UF_INDUSTRY_ID === enterpriseId
      })
      this.allquestionsanswerArr = filteredquestions
    },
    gotomenikunder () {
      this.$router.push('/alle-moeder')
    }
  }
}
</script>

<style>
#tenderQA .projectdesccontainer {
  height: 766px;
}
#tenderQA .deschover:hover {
  background-color: #e9f7fa;
}
#tenderQA .lowercase {
  text-transform: lowercase;
}
#downloadpdf .modal-header .modal-content .modal-footer {
  height: 800px!important;
}
#tenderQA .questiondiv {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 0.5px solid #dfdede;
  border-radius: 1px;
  opacity: 1;
}
#tenderQA .descreptionline {
  /** border: .5rem solid lightgray; */
}
#tenderQA .descreptionline:hover {
  transform: scale(1.09);
}
/** #tenderQA .addquestionicon {
  display: none;
} */
#TenderFolder .gap-15 {
  gap: 15px;
}
#tenderQA .deschover:hover > .addquestionicon {
  display: block!important;
  height: unset;
  width: unset;
  overflow: auto;
  clip: revert;
}
#tenderQA .industryquestionsdiv {
  height: 30px;
  background: #ace7f3 0% 0% no-repeat;
  border-radius: 3px;
  width: max-content;
}
#tenderQA .graymuteddark {
  color: #707070;
}
#tenderQA .questionsgray {
  color: #707070;
}
#tenderQA .bordercece {
  border: 1px solid #CECECE;
}
#tenderQA .font14 {
  font-size: 14px;;
}
#tenderQA .font12 {
  font-size: 12px;;
}
#tenderQA .el-tag.el-tag--info {
  background-color: #003645;
  border-color: #e9e9eb;
  color: #ffffff;
}
#tenderQA .modal-dialog {
  max-width: 1200px;
}
#modal-xl .modal-dialog {
  max-width: 1200px;
}
#tenderQA .height-full {
  height: 100%;
}

</style>


// WEBPACK FOOTER //
// tenderFolder.vue?6f49a8fe